import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductOffering from './product-offering';
import ProductOfferingDetail from './product-offering-detail';
import ProductOfferingUpdate from './product-offering-update';
import ProductOfferingDeleteDialog from './product-offering-delete-dialog';

const ProductOfferingRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductOffering />} />
    <Route path="new" element={<ProductOfferingUpdate />} />
    <Route path=":id">
      <Route index element={<ProductOfferingDetail />} />
      <Route path="edit" element={<ProductOfferingUpdate />} />
      <Route path="delete" element={<ProductOfferingDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductOfferingRoutes;
